export default __webpack_public_path__ + "static/media/arrow-left.4d3d1f30.svg";